import { NavLink, useParams } from 'react-router-dom';
import { GitFork, List } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * Segmented control shown at the top of both the flow and list views. The
 * two views share the same task data and run/selected-task state (Zustand),
 * so switching is cheap and preserves context.
 */
export function ViewToggle() {
  const { projectId } = useParams<{ projectId: string }>();
  if (!projectId) return null;
  return (
    <div
      role="tablist"
      aria-label="移行作業ビュー切替"
      className="inline-flex overflow-hidden rounded-md border border-slate-200 bg-white text-xs"
    >
      <ToggleLink to={`/projects/${projectId}/dag`} icon={<GitFork className="h-3.5 w-3.5" />}>
        フロー
      </ToggleLink>
      <ToggleLink to={`/projects/${projectId}/list`} icon={<List className="h-3.5 w-3.5" />}>
        リスト
      </ToggleLink>
    </div>
  );
}

function ToggleLink({
  to,
  icon,
  children,
}: {
  to: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <NavLink
      to={to}
      end
      className={({ isActive }) =>
        cn(
          'flex items-center gap-1 px-3 py-1 transition-colors',
          isActive
            ? 'bg-slate-900 text-white'
            : 'text-slate-700 hover:bg-slate-100',
        )
      }
    >
      {icon}
      {children}
    </NavLink>
  );
}
